import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { useContentMetafieldData } from '@jbhi-fi/components/src/hooks/useContentMetafieldData/useContentMetafieldData';
import { UseContentProps } from '@jbhi-fi/components/src/types';
import { HomeProps } from '../../views/Home/Home';
import { contentfulApiHomepageToHomeProps } from '../../transformers/contentfulApiHomepageToHomeProps';
import { useContentfulEntries } from '@jbhi-fi/components/src/hooks/useContentfulEntries/useContentfulEntries';
import { ContentfulContentHubHomepage } from '@jbhi-fi/apis/src/contentful/types';

export const HomepagePropsContext = createContext<UseContentProps<HomeProps> | null>(null);

export const HomepagePropsProvider = ({ children }: { children: ReactNode }) => {
  const metafieldData = useContentMetafieldData<ContentfulContentHubHomepage>();

  const { entries, isLoading, error } = useContentfulEntries<ContentfulContentHubHomepage>({
    filter: {
      'sys.id': metafieldData.sys.id,
    },
    autoRefresh: window.Jbhifi.isContentPreview,
  });

  const data = entries?.length && entries[0];
  const [homepageProps, setHomepageProps] = useState<HomeProps>(contentfulApiHomepageToHomeProps(metafieldData));

  useEffect(() => {
    setHomepageProps(contentfulApiHomepageToHomeProps(data || metafieldData));
  }, [data]);

  return (
    <HomepagePropsContext.Provider value={{ data: homepageProps, isLoading, error }}>
      {children}
    </HomepagePropsContext.Provider>
  );
};

export const useHomepageProps = (): UseContentProps<HomeProps> | null => {
  const context = useContext(HomepagePropsContext);
  if (context === undefined || context === null) {
    throw new Error('useHomepageProps must be used within a HomepageProps provider');
  }

  return context;
};
